var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 24,
    viewBox: "0 0 63 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9439_149497)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1138 12.3076L62.8802 4.29026C62.9703 4.1389 63.0105 3.97199 62.9973 3.80501C62.984 3.63804 62.9177 3.47643 62.8045 3.33517C62.6912 3.19391 62.5347 3.0776 62.3495 2.99702C62.1643 2.91645 61.9564 2.87422 61.7451 2.87427H51.7106C51.4472 2.87422 51.1905 2.93979 50.9768 3.0617C50.7632 3.18361 50.6034 3.35566 50.5202 3.55347L45.5029 15.4693C45.4605 15.5705 45.4389 15.6764 45.439 15.7831V20.748C45.439 21.0113 45.5711 21.2639 45.8063 21.4501C46.0416 21.6364 46.3606 21.741 46.6933 21.741H61.7451C61.9564 21.741 62.1643 21.6988 62.3495 21.6182C62.5347 21.5376 62.6912 21.4213 62.8045 21.2801C62.9177 21.1388 62.984 20.9772 62.9973 20.8102C63.0105 20.6433 62.9703 20.4763 62.8802 20.325L58.1138 12.3076Z",
    fill: "#3703A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4733 3.55347C12.3901 3.35566 12.2303 3.18361 12.0166 3.0617C11.803 2.93979 11.5463 2.87422 11.2829 2.87427H1.2484C1.03777 2.87513 0.830801 2.91798 0.646594 2.99885C0.462388 3.07971 0.306872 3.19601 0.194395 3.33699C0.0819167 3.47798 0.0160985 3.63912 0.00301178 3.80554C-0.0100749 3.97197 0.0299911 4.13833 0.119514 4.28927L4.88592 12.3066L0.119514 20.325C0.0297098 20.476 -0.0105793 20.6424 0.00236852 20.809C0.0153163 20.9756 0.0810835 21.1369 0.193594 21.278C0.306105 21.4191 0.461729 21.5355 0.646089 21.6164C0.83045 21.6974 1.0376 21.7402 1.2484 21.741H16.3002C16.6329 21.741 16.9519 21.6364 17.1871 21.4501C17.4224 21.2639 17.5545 21.0113 17.5545 20.748V15.7831C17.5546 15.6764 17.533 15.5705 17.4905 15.4693L12.4733 3.55347Z",
    fill: "#3703A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6468 0H11.2041C10.4107 0 9.76758 0.510632 9.76758 1.14053V18.8187C9.76758 19.4486 10.4107 19.9592 11.2041 19.9592H51.6468C52.4402 19.9592 53.0834 19.4486 53.0834 18.8187V1.14053C53.0834 0.510632 52.4402 0 51.6468 0Z",
    fill: "#5A34E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9439_149497",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 45,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6468 0H11.2041C10.4107 0 9.76758 0.510632 9.76758 1.14053V18.8187C9.76758 19.4486 10.4107 19.9592 11.2041 19.9592H51.6468C52.4402 19.9592 53.0834 19.4486 53.0834 18.8187V1.14053C53.0834 0.510632 52.4402 0 51.6468 0Z",
    fill: "#FF463A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9439_149497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1926 10.192C41.1926 15.3518 37.0097 19.5346 31.8499 19.5346C26.6902 19.5346 22.5073 15.3518 22.5073 10.192C22.5073 5.0322 26.6902 0.849365 31.8499 0.849365C37.0097 0.849365 41.1926 5.0322 41.1926 10.192ZM24.1986 10.192C24.1986 14.4177 27.6242 17.8433 31.8499 17.8433C36.0757 17.8433 39.5013 14.4177 39.5013 10.192C39.5013 5.96628 36.0757 2.54066 31.8499 2.54066C27.6242 2.54066 24.1986 5.96628 24.1986 10.192Z",
    fill: "#8133CF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1105 10.1915C50.1105 20.2765 41.935 28.4521 31.8499 28.4521C21.7649 28.4521 13.5894 20.2765 13.5894 10.1915C13.5894 0.106451 21.7649 -8.06909 31.8499 -8.06909C41.935 -8.06909 50.1105 0.106451 50.1105 10.1915ZM16.8951 10.1915C16.8951 18.4508 23.5906 25.1464 31.8499 25.1464C40.1093 25.1464 46.8048 18.4508 46.8048 10.1915C46.8048 1.93214 40.1093 -4.76339 31.8499 -4.76339C23.5906 -4.76339 16.8951 1.93214 16.8951 10.1915Z",
    fill: "#8133CF",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9439_149497",
    x: 0,
    y: 0,
    width: 62.9995,
    height: 23.4396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.69866
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9439_149497"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9439_149497",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleRibbon);
export default __webpack_public_path__ + "static/media/purple_ribbon.fd0a9a78c2d401dd7b3a7cda2e771b3a.svg";
export { ForwardRef as ReactComponent };